/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><es-layout custom-class="custom-class" navbarTitle="联系方式核验" :layout="(['header', 'footer'])" :navbarStyle="(navbarStyle)" :esMainStyle="(esMainStyle)" :leftArrow="(true)"><div class="verify-main"><mpx-image mode="widthFix" :style='["width: 100%; box-sizing: border-box;\n    padding: 10px 17px;"] | transRpxStyle' src="https://img-hxy021.didistatic.com/static/starimg/img/GKpTRbIyQn1683717815389.png"/><div class="verify-card"><div><span class="verify-card__status">当前状态 {{mobileStatusTxt}}</span><span class="verify-card__time">{{refreshTime}}秒后自动刷新</span></div><mpx-view @tap="refreshStatus" class="verify-card__refresh">刷新</mpx-view></div><order-title-card title="请按照以下提示完成核验" :customStyle="(customStyle)"><div class="verify-tips verify-tips__title">1.发送短信</div><div class="verify-tips verify-tips__subtitle">请告知乘客{{passengerName}}使用手机号码{{passengerPhone}}发送下方验证码至12306</div><div class="verify-tips verify-tips__title">2.验证码</div><div class="verify-code-card"><span class="verify-code-card__code">{{captcha}}</span><div class="es-flex"><span class="verify-code-card__time">倒计时{{consultTimeTxt}}</span><mpx-view @click="copy" class="verify-code-card__copy">复制</mpx-view></div></div></order-title-card><warm-tips title="温馨提示" :content="(warmTips)" from="success" v-if="(isShowWarmTips)"/></div><div slot="footer" class="footer"><es-button custom-class="left-button" size="large" :style='["flex:1;margin-right:4px"] | transRpxStyle' @click="ownCheck">我来核验</es-button><es-button custom-class="right-button" size="large" :style='["flex:1;margin-left:4px"] | transRpxStyle' @click="otherCheck">邀请好友核验</es-button></div></es-layout><es-toast id="es-toast"/></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m42f2a6c7"}'>
  .verify-main
    padding 0 12px
    background-repeat no-repeat
    background-size 100vw
    background-image url('https://img-hxy021.didistatic.com/static/starimg/img/GhAT99OZEA1683711738840.png')
    background linear-gradient(to bottom, #1473FF, #F0F1F4)
  .verify-card
    font-size 12px
    margin-top -10px
    background rgba(255, 255, 255, 0.8)
    display flex
    padding 16px
    justify-content space-between
    border-radius 8px
    &__status
      font-family PingFangSC-Semibold
      color #333333
      font-weight 600
    &__time
      color #999999
      margin-left 14px
    &__refresh
      color #1473FF
  .verify-code-card
    background #F6F7F8
    padding 12px 16px
    border-radius 8px
    font-size 12px
    display flex
    justify-content space-between
    &__code
      color #333333
      height 24px
      line-height 26px
    &__time
      color #FF7D41
      height 24px
      line-height 26px
    &__copy
      height 24px
      width 60px
      background #fff
      border 1px solid #e5e5e5
      border-radius 4px
      color #1473ff
      line-height 24px
      text-align center
      margin-left 9px
  .verify-tips
    font-size 12px
    color #333333
    &__title
      font-weight bold
      margin-bottom 4px
    &__subtitle
      font-weight 400
      margin-bottom 20px
  .footer
    background white
    height 88px
    padding 0px 12px
    position fixed
    left 0
    right 0
    bottom 0
    display flex
    justify-content space-around
    align-items center
    box-shadow 0 -4px 10px RGBA(0, 0, 0, 0.04)
    font-size 12px
  .left-button
    font-size 16px
    font-weight 600
    height 48px
    color #1473FF
    box-sizing border-box
    text-align center
    font-family PingFangSC
    border 1px solid #1473FF
    border-radius 8px
    background-color #ffffff
    text-align center
  .right-button
    font-size 16px
    font-weight 600
    height 48px
    text-align center
    color white
    border-width 0px
    border-radius 8px
    background-color #1473FF
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m42f2a6c7"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./passenger-contact-verify-page.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./passenger-contact-verify-page.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m42f2a6c7"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-toast':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/toast/index.mpx?isComponent&outputPath=components%2Findex68e47551%2Findex")),'warm-tips':getComponent(require("../../components/warm-tips/index.mpx?isComponent&outputPath=components%2Findexfd0d1b18%2Findex")),'order-title-card':getComponent(require("../../components/order-title-card/index.mpx?isComponent&outputPath=components%2Findex0448d4b8%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
